import get from 'lodash/get';

export default function selector(storeState) {
    const audienceSegments = get(storeState, 'categoryVisitationDashboard.audienceSegments');
    const totalSegmentCount = get(storeState, 'categoryVisitationDashboard.totalSegmentCount');
    const isLoading = get(storeState, 'categoryVisitationDashboard.isLoading');
    const organizationId = get(storeState, 'profile.organizationId');

    return {
        audienceSegments,
        totalSegmentCount,
        isLoading,
        organizationId,
    };
}
